import Post from './post';
import type { Type } from '@warp-drive/core/types/symbols';
import { hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Media from 'linced-app/models/media';
import type Comment from 'linced-app/models/posts/comment';
import type Reaction from 'linced-app/models/posts/reaction';

// Proto: posts.Post.
export default class Studentnotice extends Post {
  declare [Type]: 'posts/studentnotice';

  postType = PostTypes.STUDENT_NOTICE;

  @hasMany('posts/comment', { async: true, inverse: 'studentNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse studentNoticeId).
  declare comments: AsyncHasMany<Comment>;

  @hasMany('posts/reaction', { async: true, inverse: 'studentNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse studentNoticeId).
  declare reactions: AsyncHasMany<Reaction>;

  @hasMany('media', { async: true, inverse: 'studentNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse studentNoticeId).
  declare mediaIds: AsyncHasMany<Media>;

  // Don't trigger the Person reloads which the base Post model does.
  reloadPersonOnSave = false;
}
